// Site-wide type system uses Inter throughout (loaded in index.css).
// Existing variable names are kept so every component that imports them
// keeps working without a rewrite; they now all resolve to Inter weights.

export const POPPINS_LIGHT = `
  font-family: 'Inter', sans-serif;
  font-weight: 300;
`

export const POPPINS_REGULAR = `
  font-family: 'Inter', sans-serif;
  font-weight: 400;
`

export const POPPINS_MEDIUM = `
  font-family: 'Inter', sans-serif;
  font-weight: 500;
`

export const POPPINS_SEMI_BOLD = `
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  letter-spacing: -0.01em;
`

export const POPPINS_BOLD = `
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  letter-spacing: -0.01em;
`

// Sans-serif fonts
export const MONTSERRAT_REGULAR = `
  font-family: 'Inter', sans-serif;
  font-weight: 400;
`;

export const MONTSERRAT_MEDIUM = `
  font-family: 'Inter', sans-serif;
  font-weight: 500;
`;

export const MONTSERRAT_SEMI_BOLD = `
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  letter-spacing: -0.01em;
`;

export const MONTSERRAT_BOLD = `
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  letter-spacing: -0.01em;
`;

export const MONTSERRAT_LIGHT = `
  font-family: 'Inter', sans-serif;
  font-weight: 300;
`;

// Serif fonts - repurposed to Inter for a unified type system
export const PLAYFAIR_DISPLAY_REGULAR = `
  font-family: 'Inter', sans-serif;
  font-weight: 400;
`;

export const PLAYFAIR_DISPLAY_MEDIUM = `
  font-family: 'Inter', sans-serif;
  font-weight: 500;
`;

export const PLAYFAIR_DISPLAY_SEMI_BOLD = `
  font-family: 'Inter', sans-serif;
  font-weight: 600;
`;

export const PLAYFAIR_DISPLAY_BOLD = `
  font-family: 'Inter', sans-serif;
  font-weight: 700;
`;

export const PLAYFAIR_DISPLAY_LIGHT = `
  font-family: 'Inter', sans-serif;
  font-weight: 300;
`;

export const LATO_REGULAR = `
  font-family: 'Inter', sans-serif;
  font-weight: 400;
`;

export const LATO_BOLD = `
  font-family: 'Inter', sans-serif;
  font-weight: 700;
`;

export const ROBOTO_SLAB_REGULAR = `
  font-family: 'Inter', sans-serif;
  font-weight: 400;
`;

export const ROBOTO_SLAB_BOLD = `
  font-family: 'Inter', sans-serif;
  font-weight: 700;
`;

export const RALEWAY_REGULAR = `
  font-family: 'Inter', sans-serif;
  font-weight: 400;
`;

export const RALEWAY_SEMI_BOLD = `
  font-family: 'Inter', sans-serif;
  font-weight: 600;
`;

export const MERRIWEATHER_REGULAR = `
  font-family: 'Inter', sans-serif;
  font-weight: 400;
`;

export const MERRIWEATHER_BOLD = `
  font-family: 'Inter', sans-serif;
  font-weight: 700;
`;
